import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';
import { UiTranslationService } from '@core/services/ui-translation.service';
import { VidstackPlayerComponent } from '@/app/components/vidstack-player/vidstack-player';
import { TrainAsset, TrainFlashcard } from '../../deck-train.models';

@Component({
  selector: 'app-fallback-train-card',
  imports: [VidstackPlayerComponent],
  templateUrl: './fallback-train-card.html',
  styleUrl: './fallback-train-card.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FallbackTrainCard {
  private readonly deckTranslations =
    inject(UiTranslationService).namespace('deck');

  readonly card = input.required<TrainFlashcard>();
  readonly isAnswerVisible = input.required<boolean>();
  readonly sessionProgressLabel = input.required<string>();

  readonly flip = output<MouseEvent>();

  readonly t = this.deckTranslations.t;

  isImage(asset: TrainAsset): boolean {
    return asset.mimeType.toLowerCase().startsWith('image/');
  }

  isAudio(asset: TrainAsset): boolean {
    return asset.mimeType.toLowerCase().startsWith('audio/');
  }

  isVideo(asset: TrainAsset): boolean {
    return asset.mimeType.toLowerCase().startsWith('video/');
  }
}
